import { render, staticRenderFns } from "./ComContainer.vue?vue&type=template&id=223c0301&scoped=true&"
import script from "./ComContainer.vue?vue&type=script&lang=js&"
export * from "./ComContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c0301",
  null
  
)

export default component.exports